import { PrescriptionV3PrescriptionTypeEnum } from '@redteclab/api/clients/bully'

import { type PublicGlobalConfig } from '../../../global-config'

export const prescriptionAccessorGetPrescriptionLegalNote = (
  currentPrescriptionType: PrescriptionV3PrescriptionTypeEnum,
  superScripts: PublicGlobalConfig['superScripts'],
): number | undefined => {
  switch (currentPrescriptionType) {
    case PrescriptionV3PrescriptionTypeEnum.FreePrescription:
    case PrescriptionV3PrescriptionTypeEnum.InsurancePrescription: {
      return superScripts.publicPrescriptionBonus
    }
    case PrescriptionV3PrescriptionTypeEnum.PrivatePrescription: {
      return superScripts.privatePrescriptionBonus
    }
    default: {
      return undefined
    }
  }
}
